import {Pipe, PipeTransform} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TtmStatus} from '../classes/ttmstatus';
import {Ttm} from '../classes/ttm';
import {PresentTtmStatusesPipe} from './present-ttm-statuses.pipe';

@Pipe({
    name: 'countEnabledStatuses'
})
export class CountEnabledStatusesPipe implements PipeTransform {

    transform(formGroup: FormGroup, ttmStatuses: TtmStatus[], ttms: Ttm[], ...trigger: unknown[]): number {
        let count = 0;
        const presentStatusses = (new PresentTtmStatusesPipe()).transform(ttmStatuses, ttms);
        Object.keys(formGroup.value).forEach(key => {
            if (formGroup.value[key] && presentStatusses.find(ps => ps.key === key)) {
                count++;
            }
        });
        return count;
    }

}
